// extracted by mini-css-extract-plugin
export default {"page--title":"UpdateSpendingDemandPage_page--title__os9ly"};